import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle, Stack,
    useMediaQuery,
    useTheme
} from "@mui/material";
import { useEffect, useState } from "react";

const ResponsiveDialog = props => {
    const [open, setOpen] = useState(props.isOpen || false);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const minWidth = props.minWidth || '500px';
    const minHeight = props.minHeight || '30dvh';

    useEffect(() => {
        setOpen(props.isOpen);
    }, [props.isOpen]);

    const handleClose = (event, reason) => {
        if (props.preventBackdropClick && reason && reason === "backdropClick")
            return;
        if (props.onClose) return props.onClose();
        setOpen(false);
    };

    return (
        <>
            <Dialog
                fullScreen={fullScreen}
                open={open}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
                sx={{ display: { sx: "flex", sm: 'initial' } }}
            >
                <DialogTitle fontSize={{ xs: '1.5rem', sm: "2rem", borderBottom: '1px solid #ddd' }} id="responsive-dialog-title">{props.title}</DialogTitle>
                <Stack flexGrow={1} boxSizing={"border-box"} p={0} minHeight={minHeight} minWidth={{ xs: '100dvw', sm: minWidth }} width={'100%'} justifyContent='center' alignItems='center'>
                    <DialogContent sx={{ display: 'flex' }} p={1} px={{ xs: 1, sm: 4 }}>
                        {props.children}
                    </DialogContent>
                </Stack>
                <DialogActions sx={{ borderTop: '1px solid #ddd' }}>
                    {props.actions}
                </DialogActions>
            </Dialog>
        </>
    );
}

export default ResponsiveDialog;
